import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { Subject, takeUntil } from 'rxjs';
import { KsefMonitoringApiService } from 'shared/services/api/ksef-monitoring.api.service';

@Component({
  selector: 'app-ksef-dashboard',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatButtonModule
  ],
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class KsefDashboardComponent implements OnInit, OnDestroy {
  
  stats: any = null;
  isLoading = true;
  
  private _unsubscribeAll: Subject<any> = new Subject<any>();

  constructor(
    private _ksefApiService: KsefMonitoringApiService
  ) {}

  ngOnInit(): void {
    this.loadStats();
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  loadStats() {
    this.isLoading = true;
    this._ksefApiService.getBatchStats()
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe({
        next: (response) => {
          this.stats = response.data;
          this.isLoading = false;
        },
        error: (error) => {
          console.error('Błąd podczas ładowania statystyk:', error);
          this.isLoading = false;
        }
      });
  }

  refresh() {
    this.loadStats();
  }
}

